// extracted by mini-css-extract-plugin
export default {"icon-container":"PartFour_icon-container__19cFH","icon-circle":"PartFour_icon-circle__t3diM"};